import React from 'react';
import { motion } from 'framer-motion';
export const StatsBar = () => {
  const stats = [{
    value: '+500',
    label: 'instructoras confían'
  }, {
    value: '6+6',
    label: 'Tomos + Bonos'
  }, {
    value: '4.9/5',
    label: 'calificación ⭐'
  }, {
    value: '🇦🇷',
    label: 'Todo el país'
  }];
  return <div className="bg-sage-50 border-y border-sage-100 py-4 md:py-8" data-id="element-371">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-372">
        <div className="grid grid-cols-4 gap-2 md:gap-8 text-center" data-id="element-373">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col items-center justify-center" data-id="element-374">
              <span className="text-xl md:text-4xl font-bold text-sage mb-0.5 md:mb-2 font-playfair" data-id="element-375">
                {stat.value}
              </span>
              <span className="text-[10px] md:text-base text-gray-600 font-medium uppercase tracking-wider leading-tight" data-id="element-376">
                {stat.label}
              </span>
            </motion.div>)}
        </div>
      </div>
    </div>;
};